import { logger } from '../services/logger';
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { MarketChat as ChatComponent } from '../components/MarketChat';
import { MarketEngine } from '../lib/marketEngine';
import { Market } from '../types';

const marketEngine = new MarketEngine();

export function MarketChat() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [market, setMarket] = React.useState<Market | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchMarket = async () => {
      try {
        if (!id) throw new Error('Market ID not provided');
        const marketData = await marketEngine.getMarket(id);
        setMarket(marketEngine.toDisplayMarket(marketData));
        setError(null);
      } catch (error) {
        logger.error('Error fetching market:', error);
        setError('Failed to load market details');
      } finally {
        setLoading(false);
      }
    };

    fetchMarket();
  }, [id]);

  const handleBack = () => {
    navigate(`/markets/${id}`);
  };

  if (loading) {
    return (
      <div className="py-8">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-wayja-teal"></div>
        </div>
      </div>
    );
  }

  if (error || !market) {
    return (
      <div className="py-8">
        <div className="text-center text-red-600">{error || 'Market not found'}</div>
      </div>
    );
  }

  return (
    <div className="py-8">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <button
          onClick={handleBack}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Back to Market</span>
        </button>

        {/* Market Title */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold">{market.title}</h1>
          <p className="text-gray-600">Market Chat</p>
        </div>

        {/* Chat Component */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <ChatComponent marketId={market.id} />
        </div>
      </div>
    </div>
  );
}